/**
 * Utility-Funktionen für Cloud Function URLs
 * Bestimmt automatisch die richtige Umgebung basierend auf Environment Variables
 */

/**
 * Gibt die Base URL für Cloud Functions basierend auf der aktuellen Umgebung zurück
 * @returns {string} Die Base URL für Cloud Functions
 */
export const getCloudFunctionBaseUrl = () => {
  const environment = process.env.REACT_APP_ENV;
  const projectId = process.env.REACT_APP_PROJECT_ID;
  
  console.log('🌍 [CLOUD-FUNCTIONS] Environment:', environment);
  console.log('🌍 [CLOUD-FUNCTIONS] Project ID:', projectId);
  
  // Wenn explizit development/dev gesetzt ist, verwende dev
  if (environment === 'development' || environment === 'dev') {
    return 'https://us-central1-bonusclub-dev.cloudfunctions.net';
  }
  
  // Wenn PROJECT_ID explizit auf dev gesetzt ist, verwende dev
  if (projectId === 'bonusclub-dev' || projectId === 'bonusclub-dev-461411') {
    return 'https://us-central1-bonusclub-dev.cloudfunctions.net';
  }
  
  // Standard: Production
  return 'https://us-central1-bonusclub-ab5e2.cloudfunctions.net';
};

/**
 * Erstellt die vollständige URL für eine Cloud Function
 * @param {string} functionName - Name der Cloud Function
 * @returns {string} Vollständige URL zur Cloud Function
 */
export const getCloudFunctionUrl = (functionName) => {
  const baseUrl = getCloudFunctionBaseUrl();
  const fullUrl = `${baseUrl}/${functionName}`;
  
  console.log(`🌍 [CLOUD-FUNCTIONS] ${functionName}: ${fullUrl}`);
  
  return fullUrl;
};

/**
 * Vordefinierte URLs für häufig verwendete Cloud Functions
 */
export const CLOUD_FUNCTION_URLS = {
  sendWorldEmail: () => getCloudFunctionUrl('sendWorldEmail'),
  worldEmailCreator: () => getCloudFunctionUrl('worldEmailCreator'),
  cleanupContact: () => getCloudFunctionUrl('cleanupContact'),
  testEmailConnection: () => getCloudFunctionUrl('testEmailConnection'),
  fetchEmailContent: () => getCloudFunctionUrl('fetchEmailContent'),
  cancelScheduledEmail: () => getCloudFunctionUrl('cancelScheduledEmail'),
  getEmailSettings: () => getCloudFunctionUrl('getEmailSettings'),
  updateEmailSettings: () => getCloudFunctionUrl('updateEmailSettings'),
  updateSenderDelay: () => getCloudFunctionUrl('updateSenderDelay'),
  worldWebCrawler: () => getCloudFunctionUrl('worldWebCrawler'),
  fetchInbox: () => getCloudFunctionUrl('fetchInbox'),
  deleteEmail: () => getCloudFunctionUrl('deleteEmail'),
  markEmailAsRead: () => getCloudFunctionUrl('markEmailAsRead'),
  hotelFetcher: () => getCloudFunctionUrl('hotelFetcher')
}; 